import styled from '@emotion/styled';

export const SHeader = styled.div`
  margin-top: 24px;
`;

export const STitle = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  padding-left: 16px;
  color: rgba(0, 0, 0, 0.85);
`;

export const SContent = styled.div`
  margin-top: 24px;
  background-color: white;
  flex-grow: 1;
`;

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const SButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-block: 12px;
`;
